module.exports = __webpack_public_path__ + "img/1.690f068c.jpg";